var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "layer",
      class: _vm.layerClass,
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.closeLayer.apply(null, arguments)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }